import type { SiretSuggestion } from "@shared-kernel/application/ports/siret-search/siret-search-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const searchSiret = createApiThunk<SiretSuggestion[], { query: string; signal?: AbortSignal }>(
  "shared/siret/search",
  async ({ query, signal }, { extra: { siretSearchRepository } }) => {
    return siretSearchRepository!.searchSiret(query, signal);
  },
);
